import { useRef, useState } from 'react';
import { PaywallRevalidateChooseMode } from './paywallRevalidateChooseMode';
import { PaywallPlans, RevalidateUserData, SignInType, SiteLinks } from '../../../../global/paywall/paywallInterfaces';
import { DetailUpdateError, RevalidationStep } from '../../../../global/paywall/useDetailsUpdate';
import { PaywallRevalidatePassword, OTP_LENGTH } from './paywallRevalidatePassword';


interface PaywallRevalidateProps {
    userData: RevalidateUserData
    step: RevalidationStep
    error: DetailUpdateError
    revalidationType: SignInType
    setRevalidationType: (type: SignInType) => void
    sendRevalidation: () => Promise<void>;
    validateOtp: (otp: string) => Promise<boolean>;
}
declare const window: Window & {
    PAYWALL_PLANS: PaywallPlans
    PAYWALL_SITE_LINKS: SiteLinks;
}

export const PaywallRevalidate = ({
    userData,
    step,
    error,
    revalidationType,
    setRevalidationType,
    sendRevalidation,
    validateOtp
}: PaywallRevalidateProps) => {

    const [otp, setOtp] = useState<string[]>(Array(OTP_LENGTH).fill(''));
    const inputRefs = useRef<Array<HTMLInputElement | null>>(Array(OTP_LENGTH).fill(null));
    const contactUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.contact : '';

  const serverErrorMessages: Partial<Record<DetailUpdateError, string>> = {
    [DetailUpdateError.AUTHENTICATION_FAILED]: 'האימות נכשל או שפג תוקפו של קוד האימות, יש לנסות שוב',
    [DetailUpdateError.OTP_MAX_ATTEMPTS]: `חרגת ממספר בקשות אימות. יש לפנות ל<a target="_blank" href=${contactUrl}>שירות הלקוחות</a>`,
  }


    const handleClose = () => {
        if (typeof window !== 'undefined') {
            if (window.history.length > 1) {
                window.history.back();
            } else {
                window.location.href = '/';
            }
        }
    };

    const resetOtpInputs = () => {
        setOtp(Array(OTP_LENGTH).fill(''));
        inputRefs.current.forEach((input) => {
            if (input) {
                input.style.borderColor = '#999999';
            }
        });
    }

    const handleContinue = () => {
        switch (step) {
            case RevalidationStep.SEND:
                sendRevalidation();
                break;
            case RevalidationStep.ENTER_OTP:
                validateOtp(otp.join(''));
                break;
            default:
                break;
        }
    };

    const handleResendCode = () => {
        resetOtpInputs();
        sendRevalidation();
    }

    const renderStepContent = () => {
        switch (step) {
            case RevalidationStep.SEND:
                return <PaywallRevalidateChooseMode
                    userData={userData}
                    revalidationType={revalidationType}
                    setRevalidationType={setRevalidationType}
                    error={error}
                />;
            case RevalidationStep.ENTER_OTP:
                return <PaywallRevalidatePassword
                    otp={otp}
                    setOtp={setOtp}
                    userData={userData}
                    revalidationType={revalidationType}
                    handleContinue={handleContinue}
                    error={error}
                    inputRefs={inputRefs}
                />;
            default:
                return null;
        }
    };



    return (
        <div className="paywall-revalidate-overlay">
            <div className="paywall-revalidate-modal">
                <button className="close-button" onClick={handleClose}></button>
                <div className="ynet-logo"></div>
                <div className="calcalist-logo">המהדורה הדיגיטלית</div>
                <div className="modal-content">
                    {renderStepContent()}
                </div>
                <button className="continue-button" onClick={handleContinue}>
                    המשך
                </button>
                {step === RevalidationStep.ENTER_OTP && <div className="resend-code-text">
                    הקוד לא הגיע?<button onClick={handleResendCode}>לשליחה מחדש</button>
                </div>}
                {!!error && step === RevalidationStep.SEND && (
                    <span className="error-text" dangerouslySetInnerHTML={{ __html: serverErrorMessages[error] }} />
                )}
            </div>
        </div>
    );
};

export default PaywallRevalidate;

PaywallRevalidate.siteScriptName = "PaywallRevalidate"



